"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalLenderSchema = void 0;
var constants_1 = require("@hobt/constants");
var authorized_officer_schema_1 = require("./authorized-officer-schema");
var claim_payee_schema_1 = require("./claim-payee-schema");
var lender_address_schema_1 = require("./lender-address-schema");
exports.finalLenderSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'address',
        'approvedLenderCode',
        'authorizedOfficers',
        'claimPayee',
        'correspondenceLanguageCode',
    ],
    properties: {
        address: lender_address_schema_1.lenderAddressSchema,
        approvedLenderCode: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        authorizedOfficers: {
            type: 'array',
            items: authorized_officer_schema_1.authorizedOfficerSchema,
        },
        claimPayee: claim_payee_schema_1.claimPayeeSchema,
        correspondenceLanguageCode: {
            type: 'integer',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
    },
};
